export default "__VITE_PUBLIC_ASSET__478cc428__"